module.exports = __webpack_public_path__ + "static/orenuga-cb6fa5ce90e1eb724e99f080026d58e8.png";